import { motion } from "framer-motion";

import CountUp from "react-countup";
import SEO from "@/components/SEO";

const Four = () => {
  const items = [
    {
      
      title: "FONCIER",
      image: "/images/foncier.webp",
      description:
        "Soutien pour l'accès au foncier via la création de zones dédiées, comme les SECA à Mékhé, Thionk Essyl, Mballing, et les zones de développement Artisanales (ZODA) prévues à DIAMNIADIO.",
      color: "from-blue-500 to-blue-600",
    },
    {
      
      title: "FORMALISATION",
      image: "/images/formalisation.webp",
      description:
        "Aider les unités de production artisanales à se formaliser en TPE/PME, en respectant les normes du cadre juridique et réglementaire des affaires au Sénégal et dans la sous-région.",
      color: "from-green-500 to-green-600",
    },
    {
      
      title: "FORMATION",
      image: "/images/formation.webp",
      description:
        "A travers un programme de renforcement de capacités techniques, administratives, managériales et de maîtrise des procédures de marché public.",
      color: "from-yellow-500 to-yellow-600",
    },
    {
      
      title: "FINANCEMENT",
      image: "/images/financement.webp",
      description:
        "Accompagner les artisans à accéder à des financements souples et adaptés du secteur, que l'État met à leur disposition et les institutions financières décentralisées.",
      color: "from-purple-500 to-purple-600",
    },
  ];

  return (
    <>
      <SEO
        title="4F"
        description="Découvrez les 4 piliers du Projet Mobilier National : Foncier, Formalisation, Formation et Financement. Notre approche intégrée pour le développement de l'artisanat."
        keywords="PMN, 4F, Foncier, Formalisation, Formation, Financement, Artisanat, Sénégal, Développement"
        ogImage="/images/formation.webp"
      />
      
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
        {/* Hero Section */}
        <section className="relative bg-[#1E3D1A] py-32">
          <div className="absolute inset-0 bg-[url('/4artisan.webp')] opacity-60" />
          <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-3xl mx-auto text-center"
            >
              <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-wider">
                PROBLÉMATIQUE DES 4 F
              </h1>
              <p className="text-xl text-white/90">
              
              </p>
            </motion.div>
          </div>
        </section>

        {/* Cards Section */}
        <section className="py-20">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
              {items.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="group"
                >
                  <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-8">
                      <div className="flex items-center space-x-4 mb-4">
                        <div
                          className={`bg-gradient-to-r ${item.color} p-3 rounded-lg`}
                        >
                         
                        </div>
                        <h3 className="text-2xl font-bold text-white">
                          {item.title}
                        </h3>
                      </div>
                      <p className="text-white/90 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section className="py-20 bg-[#1E3D1A]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="max-w-4xl mx-auto text-center"
            >
              <h2 className="text-3xl font-bold text-white mb-12">
                Impact des 4F sur l'Artisanat
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20"
                >
                  <div className="text-5xl font-bold text-white mb-2">
                    +<CountUp end={50} duration={1} />%
                  </div>
                  <div className="text-white/80">Formalisation des Artisans</div>
                </motion.div>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20"
                >
                  <div className="text-5xl font-bold text-white mb-2">
                    +<CountUp end={30} duration={1} />%
                  </div>
                  <div className="text-white/80">Accès au Financement</div>
                </motion.div>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20"
                >
                  <div className="text-5xl font-bold text-white mb-2">
                    +<CountUp end={40} duration={1} />%
                  </div>
                  <div className="text-white/80">Formation Complétée</div>
                </motion.div>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20"
                >
                  <div className="text-5xl font-bold text-white mb-2">
                    +<CountUp end={25} duration={1} />%
                  </div>
                  <div className="text-white/80">Accès au Foncier</div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Four;
